import styled from 'styled-components';

export default styled.div`
  height: 100vh;
`;



// WEBPACK FOOTER //
// ./src/app/components/full_height/index.js